(function () {
  function initAll() {
    var roots = document.querySelectorAll('.stone-visualiser');
    roots.forEach(initOne);
  }

  function initOne(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    var sectionId = root.id.replace('stone-visualiser-', '');
    var catalogScript = document.querySelector('script[data-role="stone-catalog"][data-section="' + sectionId + '"]');
    var cabinetScript = document.querySelector('script[data-role="cabinet-options"][data-section="' + sectionId + '"]');
    var stoneCatalog = [];
    var cabinetOptions = [];
    try { stoneCatalog = JSON.parse(catalogScript.textContent); } catch (e) { stoneCatalog = []; }
    try { cabinetOptions = JSON.parse(cabinetScript.textContent); } catch (e) { cabinetOptions = []; }

    if (!stoneCatalog.length) {
      root.querySelector('[data-viewport]').innerHTML =
        '<p style="padding:2rem;font-size:14px;color:#5f5e5a;">No stones found. Pick a collection with products in the section settings.</p>';
      return;
    }
    if (!cabinetOptions.length) {
      cabinetOptions = [{ name: 'White', hex: 'f4f2ec' }];
    }

    var viewport = root.querySelector('[data-viewport]');
    var categoriesEl = root.querySelector('[data-categories]');
    var swatchesEl = root.querySelector('[data-swatches]');
    var pairHintEl = root.querySelector('[data-pair-hint]');
    var selectedInfoEl = root.querySelector('[data-selected-info]');
    var tabButtons = root.querySelectorAll('[data-surface]');
    var viewButtons = root.querySelectorAll('[data-view]');

    var categories = ['All'];
    stoneCatalog.forEach(function (s) {
      if (s.category && categories.indexOf(s.category) === -1) categories.push(s.category);
    });

    var scene = new THREE.Scene();
    var bgCanvas = document.createElement('canvas');
    bgCanvas.width = 4; bgCanvas.height = 512;
    var bgCtx = bgCanvas.getContext('2d');
    var bgGrad = bgCtx.createLinearGradient(0, 0, 0, 512);
    bgGrad.addColorStop(0, '#14120f');
    bgGrad.addColorStop(0.5, '#2c2a25');
    bgGrad.addColorStop(0.82, '#3f3c35');
    bgGrad.addColorStop(1, '#4c4941');
    bgCtx.fillStyle = bgGrad;
    bgCtx.fillRect(0, 0, 4, 512);
    scene.background = new THREE.CanvasTexture(bgCanvas);

    var camera = new THREE.PerspectiveCamera(38, 1.6, 0.1, 100);
    var renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.15;
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    viewport.appendChild(renderer.domElement);

    var lastW = 0, lastH = 0;
    function syncRendererSize() {
      var w = viewport.clientWidth;
      var h = viewport.clientHeight;
      if (w < 2 || h < 2) return;
      if (w === lastW && h === lastH) return;
      lastW = w; lastH = h;
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      renderer.setSize(w, h, false);
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(syncRendererSize);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(syncRendererSize).observe(viewport);
    } else {
      window.addEventListener('resize', syncRendererSize);
    }

    scene.add(new THREE.HemisphereLight(0xffffff, 0xd8d4c6, 0.55));
    var dirLight = new THREE.DirectionalLight(0xfff4e0, 0.9);
    dirLight.position.set(3, 5, 4);
    dirLight.castShadow = true;
    dirLight.shadow.mapSize.set(1024, 1024);
    dirLight.shadow.camera.left = -4;
    dirLight.shadow.camera.right = 4;
    dirLight.shadow.camera.top = 4;
    dirLight.shadow.camera.bottom = -4;
    dirLight.shadow.bias = -0.002;
    scene.add(dirLight);
    var fillLight = new THREE.DirectionalLight(0xdce8ff, 0.25);
    fillLight.position.set(-4, 3, 2);
    scene.add(fillLight);
    var rimLight = new THREE.DirectionalLight(0xffffff, 0.5);
    rimLight.position.set(0, 3.5, -3.5);
    scene.add(rimLight);

    var contactShadowCanvas = document.createElement('canvas');
    contactShadowCanvas.width = 256; contactShadowCanvas.height = 128;
    var csCtx = contactShadowCanvas.getContext('2d');
    var csGrad = csCtx.createRadialGradient(128, 64, 10, 128, 64, 120);
    csGrad.addColorStop(0, 'rgba(20,18,14,0.38)');
    csGrad.addColorStop(1, 'rgba(20,18,14,0)');
    csCtx.fillStyle = csGrad;
    csCtx.fillRect(0, 0, 256, 128);
    var contactShadow = new THREE.Mesh(
      new THREE.PlaneGeometry(7, 2),
      new THREE.MeshBasicMaterial({ map: new THREE.CanvasTexture(contactShadowCanvas), transparent: true, depthWrite: false })
    );
    contactShadow.rotation.x = -Math.PI / 2;
    contactShadow.position.set(0, 0.005, -1.6);
    scene.add(contactShadow);

    var woodA = 0xdfc9a3, woodB = 0xd2b58c;
    for (var i = 0; i < 10; i++) {
      var plank = new THREE.Mesh(new THREE.BoxGeometry(6, 0.02, 0.4), new THREE.MeshStandardMaterial({ color: i % 2 === 0 ? woodA : woodB, roughness: 0.8 }));
      plank.position.set(0, -0.01, -2 + i * 0.4 + 0.2);
      plank.receiveShadow = true;
      scene.add(plank);
    }
    var wall = new THREE.Mesh(new THREE.PlaneGeometry(6, 3), new THREE.MeshStandardMaterial({ color: 0xf2ede0 }));
    wall.position.set(0, 1.5, -2);
    wall.receiveShadow = true;
    scene.add(wall);

    var sideWallMat = new THREE.MeshStandardMaterial({ color: 0xe6dfcd, side: THREE.DoubleSide });
    var wallLeft = new THREE.Mesh(new THREE.PlaneGeometry(4, 3), sideWallMat);
    wallLeft.rotation.y = Math.PI / 2;
    wallLeft.position.set(-3, 1.5, 0);
    wallLeft.receiveShadow = true;
    scene.add(wallLeft);
    var wallRight = new THREE.Mesh(new THREE.PlaneGeometry(4, 3), sideWallMat);
    wallRight.rotation.y = -Math.PI / 2;
    wallRight.position.set(3, 1.5, 0);
    wallRight.receiveShadow = true;
    scene.add(wallRight);

    var windowGlass = new THREE.Mesh(new THREE.PlaneGeometry(1.1, 1.3), new THREE.MeshStandardMaterial({ color: 0xbcd4e0, roughness: 0.1, metalness: 0.1 }));
    windowGlass.position.set(2.15, 2.2, -1.98);
    scene.add(windowGlass);
    var frameMat = new THREE.MeshStandardMaterial({ color: 0xf7f5ef, roughness: 0.7 });
    [[-0.55, 0], [0.55, 0]].forEach(function (o) {
      var m = new THREE.Mesh(new THREE.BoxGeometry(0.03, 1.3, 0.04), frameMat);
      m.position.set(2.15 + o[0], 2.2, -1.96);
      scene.add(m);
    });
    [[-0.65], [0.65]].forEach(function (o) {
      var m = new THREE.Mesh(new THREE.BoxGeometry(1.1, 0.03, 0.04), frameMat);
      m.position.set(2.15, 2.2 + o[0], -1.96);
      scene.add(m);
    });

    var soffit = new THREE.Mesh(new THREE.BoxGeometry(6.4, 0.15, 0.7), new THREE.MeshStandardMaterial({ color: 0xe4dfd0, roughness: 0.9 }));
    soffit.position.set(0, 2.78, -1.85);
    soffit.receiveShadow = true;
    scene.add(soffit);
    var ceiling = new THREE.Mesh(new THREE.PlaneGeometry(6, 4), new THREE.MeshStandardMaterial({ color: 0xf7f4ea }));
    ceiling.rotation.x = Math.PI / 2;
    ceiling.position.set(0, 2.95, 0);
    scene.add(ceiling);

    var cabinetMat = new THREE.MeshStandardMaterial({ color: parseInt(cabinetOptions[0].hex, 16), roughness: 0.55 });
    var handleMat = new THREE.MeshStandardMaterial({ color: 0xb8b4a8, metalness: 0.85, roughness: 0.25 });
    var kickboard = new THREE.Mesh(new THREE.BoxGeometry(6, 0.1, 0.62), new THREE.MeshStandardMaterial({ color: 0x2a2a28, roughness: 0.7 }));
    kickboard.position.set(0, 0.05, -1.6);
    scene.add(kickboard);
    for (i = 0; i < 5; i++) {
      var door = new THREE.Mesh(new THREE.BoxGeometry(1.14, 0.85, 0.68), cabinetMat);
      door.position.set(-2.4 + i * 1.2, 0.55, -1.6);
      door.castShadow = true; door.receiveShadow = true;
      scene.add(door);
      var handle = new THREE.Mesh(new THREE.BoxGeometry(0.2, 0.035, 0.035), handleMat);
      handle.position.set(-2.4 + i * 1.2, 0.9, -1.24);
      scene.add(handle);
    }
    for (i = 0; i < 4; i++) {
      if (i === 2) continue;
      var upperDoor = new THREE.Mesh(new THREE.BoxGeometry(1.35, 0.8, 0.38), cabinetMat);
      upperDoor.position.set(-2.0 + i * 1.35, 2.42, -1.82);
      upperDoor.castShadow = true;
      scene.add(upperDoor);
    }
    var underLightBar = new THREE.Mesh(new THREE.BoxGeometry(6, 0.03, 0.1), new THREE.MeshStandardMaterial({ color: 0xfff8e8, emissive: 0xfff3c4, emissiveIntensity: 0.8 }));
    underLightBar.position.set(0, 1.99, -1.75);
    scene.add(underLightBar);

    var worktopMat = new THREE.MeshStandardMaterial({ roughness: 0.28, metalness: 0.06, color: 0xffffff });
    var worktop = new THREE.Mesh(new THREE.BoxGeometry(6.3, 0.16, 0.74), worktopMat);
    worktop.position.set(0, 1.06, -1.6);
    worktop.castShadow = true; worktop.receiveShadow = true;
    scene.add(worktop);
    var worktopEdge = new THREE.Mesh(new THREE.BoxGeometry(6.3, 0.05, 0.035), worktopMat);
    worktopEdge.position.set(0, 0.955, -1.21);
    worktopEdge.castShadow = true;
    scene.add(worktopEdge);
    var splashMat = new THREE.MeshStandardMaterial({ roughness: 0.28, metalness: 0.06, color: 0xffffff });
    var splashback = new THREE.Mesh(new THREE.BoxGeometry(6, 1.0, 0.09), splashMat);
    splashback.position.set(0, 1.64, -1.9);
    splashback.receiveShadow = true;
    scene.add(splashback);

    var sinkBasin = new THREE.Mesh(new THREE.BoxGeometry(0.7, 0.04, 0.4), new THREE.MeshStandardMaterial({ color: 0x9a9a97, metalness: 0.7, roughness: 0.3 }));
    sinkBasin.position.set(1.6, 1.08, -1.6);
    scene.add(sinkBasin);
    var tapMat = new THREE.MeshStandardMaterial({ color: 0xc9a24a, metalness: 0.9, roughness: 0.22 });
    var tapBase = new THREE.Mesh(new THREE.CylinderGeometry(0.02, 0.02, 0.28, 10), tapMat);
    tapBase.position.set(1.6, 1.28, -1.85);
    scene.add(tapBase);
    var tapArc = new THREE.Mesh(new THREE.TorusGeometry(0.1, 0.015, 8, 16, Math.PI), tapMat);
    tapArc.position.set(1.6, 1.42, -1.85);
    tapArc.rotation.set(Math.PI / 2, 0, Math.PI / 2);
    scene.add(tapArc);
    var hob = new THREE.Mesh(new THREE.BoxGeometry(0.6, 0.01, 0.4), new THREE.MeshStandardMaterial({ color: 0x1c1c1a, roughness: 0.5 }));
    hob.position.set(-1.6, 1.145, -1.55);
    scene.add(hob);

    var loader = new THREE.TextureLoader();
    loader.crossOrigin = 'anonymous';
    function applyStoneTexture(material, stone, repeatX) {
      if (!stone.image) return;
      loader.load(stone.image, function (tex) {
        tex.wrapS = THREE.RepeatWrapping;
        tex.wrapT = THREE.RepeatWrapping;
        tex.repeat.set(repeatX, 1);
        material.map = tex;
        material.needsUpdate = true;
      });
    }

    var theta = Math.PI / 6, phi = Math.PI / 2.5, radius = 6.4;
    var target = new THREE.Vector3(0, 1, -1.6);
    function updateCamera() {
      camera.position.x = target.x + radius * Math.sin(phi) * Math.sin(theta);
      camera.position.y = target.y + radius * Math.cos(phi);
      camera.position.z = target.z + radius * Math.sin(phi) * Math.cos(theta);
      camera.lookAt(target);
    }
    updateCamera();

    var dragging = false, lastX = 0, lastY = 0;
    viewport.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; lastY = e.clientY; });
    window.addEventListener('pointerup', function () { dragging = false; });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - lastX, dy = e.clientY - lastY;
      lastX = e.clientX; lastY = e.clientY;
      theta -= dx * 0.006;
      phi -= dy * 0.006;
      phi = Math.max(0.08, Math.min(Math.PI - 0.08, phi));
      updateCamera();
    });
    viewport.addEventListener('wheel', function (e) {
      e.preventDefault();
      radius = Math.max(2.5, Math.min(11, radius + e.deltaY * 0.003));
      updateCamera();
    }, { passive: false });

    viewButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-view');
        if (v === 'front') { theta = 0; phi = Math.PI / 2.4; radius = 6.4; }
        if (v === 'top') { theta = 0.3; phi = 0.2; radius = 6.4; }
        if (v === 'side') { theta = Math.PI / 2; phi = Math.PI / 2.4; radius = 6.4; }
        updateCamera();
      });
    });

    function animate() {
      requestAnimationFrame(animate);
      renderer.render(scene, camera);
    }
    animate();

    var worktopStone = stoneCatalog[0];
    var splashStone = stoneCatalog[0];
    applyStoneTexture(worktopMat, worktopStone, 4);
    applyStoneTexture(splashMat, splashStone, 4);

    var activeSurface = 'worktop';
    var activeCategory = 'All';

    function renderCategories() {
      categoriesEl.innerHTML = '';
      if (activeSurface === 'cabinet') return;
      categories.forEach(function (cat) {
        var b = document.createElement('button');
        b.type = 'button';
        b.textContent = cat === 'All' ? 'All' : cat.replace(/_/g, ' ');
        if (cat === activeCategory) b.classList.add('is-active');
        b.addEventListener('click', function () { activeCategory = cat; renderCategories(); renderSwatches(); });
        categoriesEl.appendChild(b);
      });
    }

    function updateSelectedInfo(stone) {
      if (!stone || !stone.url) { selectedInfoEl.innerHTML = ''; return; }
      selectedInfoEl.innerHTML =
        '<span class="stone-visualiser__selected-name">' + stone.name + '</span>' +
        '<span class="stone-visualiser__selected-price">' + (stone.price || '') + '</span>' +
        '<a href="' + stone.url + '" class="stone-visualiser__selected-link">View product</a>';
    }

    function renderSwatches() {
      swatchesEl.innerHTML = '';
      if (activeSurface === 'cabinet') {
        pairHintEl.textContent = 'Highlighted: colors that pair well with your selected worktop (' + worktopStone.name + ')';
        cabinetOptions.forEach(function (c) {
          var recommended = worktopStone.pairs && worktopStone.pairs.indexOf(c.name) !== -1;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'stone-visualiser__swatch' + (c.name === currentCabinetName() ? ' is-active' : '') + (recommended ? ' is-recommended' : '');
          var circle = document.createElement('div');
          circle.className = 'stone-visualiser__swatch-circle';
          circle.style.background = '#' + c.hex;
          var label = document.createElement('span');
          label.className = 'stone-visualiser__swatch-label';
          label.textContent = c.name;
          b.appendChild(circle); b.appendChild(label);
          b.addEventListener('click', function () {
            cabinetMat.color.setHex(parseInt(c.hex, 16));
            cabinetMat.currentName = c.name;
            renderSwatches();
          });
          swatchesEl.appendChild(b);
        });
        selectedInfoEl.innerHTML = '';
      } else {
        pairHintEl.textContent = 'Filter by stone type, then pick a finish';
        var list = stoneCatalog.filter(function (s) { return activeCategory === 'All' || s.category === activeCategory; });
        var current = activeSurface === 'worktop' ? worktopStone : splashStone;
        list.forEach(function (s) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'stone-visualiser__swatch' + (s.name === current.name ? ' is-active' : '');
          var circle = document.createElement('div');
          circle.className = 'stone-visualiser__swatch-circle';
          if (s.image) circle.style.background = 'url(' + s.image + ')';
          var label = document.createElement('span');
          label.className = 'stone-visualiser__swatch-label';
          label.textContent = s.name;
          b.appendChild(circle); b.appendChild(label);
          b.addEventListener('click', function () {
            if (activeSurface === 'worktop') { worktopStone = s; applyStoneTexture(worktopMat, s, 4); }
            else { splashStone = s; applyStoneTexture(splashMat, s, 4); }
            renderSwatches();
          });
          swatchesEl.appendChild(b);
        });
        updateSelectedInfo(current);
      }
    }

    function currentCabinetName() {
      return cabinetMat.currentName || cabinetOptions[0].name;
    }

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeSurface = btn.getAttribute('data-surface');
        tabButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        renderCategories();
        renderSwatches();
      });
    });

    renderCategories();
    renderSwatches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();